import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import ExpandableSection from "../../expandablesection";
import Brickmould from "./Brickmould";
import BrickmouldType from "./BrickmouldType";
import BrickmouldSize from "./BrickmouldSize";
import BrickmouldWidth  from "./BrickmouldWidth";
import BrickmouldHeight from "./BrickmouldHeight";

const PanelBrickmould = forwardRef(({ onChange }, ref) => {
  const [brickmouldValue, setBrickmouldValue] = useState(""); 
  const [brickmouldTypeValue, setBrickmouldTypeValue] = useState(""); 
  const [brickmouldSizeValue, setBrickmouldSizeValue] = useState(""); 
  const [brickmouldWidthValue, setBrickmouldWidthValue] = useState(""); 
  const [brickmouldHeightValue, setBrickmouldHeightValue] = useState(""); 


  // Method to retrieve all active controls and their values
  const getActiveControlsWithValues = () => {
    const values = {};

    controlMap
      .filter((control) => control.status === "active") // Only active controls
      .forEach((control) => {
        const element = document.getElementById(control.id); // Query by control ID
        if (element) {
          values[control.id] = element.value; // Retrieve the current value
        } else {
          values[control.id] = null; // Handle missing elements
        }
      });

    return values;
  };

  // Expose the `getActiveControlsWithValues` method to the parent via ref
  useImperativeHandle(ref, () => ({
    getActiveControlsWithValues,
  }));

  // Notify parent component whenever values change
  useEffect(() => {
    onChange({
      brickmould: brickmouldValue,
      brickmouldType: brickmouldTypeValue,
      brickmouldSize: brickmouldSizeValue,
      brickmouldHeight: brickmouldHeightValue,

    });
  }, [brickmouldValue, brickmouldTypeValue, brickmouldSizeValue, brickmouldHeightValue, onChange]);

  // Control map specific to BrickmouldPanel
  const controlMap = [
    {
      id: "Brickmould",
      component: (
        <Brickmould
          id="Brickmould"
          onChange={(newValue) => {
            setBrickmouldValue(newValue);
          }}
          childs={["BrickmouldType", "BrickmouldSize" ]}
          childs1={[ "BrickmouldWidth", "BrickmouldHeight"]}
        />
      ),
      position: [1, 1],
      status: "active",
      expandableSectionId: "BrickmouldPanel",
    }, 
    {
      id: "BrickmouldType",
      component: (
        <BrickmouldType
          id="BrickmouldType"
          onChange={(newValue) => {
            setBrickmouldTypeValue(newValue);
          }}
        />
      ),
      position: [2, 1],
      status: "active",
      expandableSectionId: "BrickmouldPanel",
    }, 
    {
      id: "BrickmouldSize",
      component: (
        <BrickmouldSize
          id="BrickmouldSize"
          onChange={(newValue) => {
            setBrickmouldSizeValue(newValue);
          }}
          brickmouldTypeValue={brickmouldTypeValue}
        />
      ),
      position: [2, 2],
      status: "active",
      expandableSectionId: "BrickmouldPanel",
    },   
    {
      id: "BrickmouldWidth",
      component: (
        <BrickmouldWidth
          id="BrickmouldHeight"
          onChange={(newValue) => {
            setBrickmouldWidthValue(newValue);
          }}
        />
      ),
      position: [3, 1],
      status: "active",
      expandableSectionId: "BrickmouldPanel",
    },   
    {
      id: "BrickmouldHeight",
      component: (
        <BrickmouldHeight
          id="BrickmouldHeight"
          onChange={(newValue) => {
            setBrickmouldHeightValue(newValue);
          }}
        />
      ),
      position: [3, 2],
      status: "active",
      expandableSectionId: "BrickmouldPanel",
    },   
  ];

  return (
    <ExpandableSection
      title="Brickmould"
      panelLocation="114"
      controlMap={controlMap.filter((control) => control.expandableSectionId === "BrickmouldPanel")}
    />
  );
});

export default PanelBrickmould;
